import React, { useState } from "react";

import { useIntl } from "react-intl";

import { selectServicesProcessesAsTree } from "Reducers/serviceProcesses/serviceProcesses.selectors";
import { useAppSelector } from "Store/hooks";

import { TreeNode } from "../components/TreeNode";
import { headersConfig } from "../utils/headersConfig";

import { TreeListRoot } from "./TreeList.styles";

export type TreeListProps = {
  search: string;
};

export const TreeList = ({ search }: TreeListProps) => {
  const { formatMessage } = useIntl();
  const [currentOpen, setCurrentOpen] = useState(0);
  const serviceProcesses = useAppSelector(state =>
    selectServicesProcessesAsTree(state, {
      orderBy: {
        direction: 1,
        field: "parent_pid"
      },
      search
    })
  );

  return (
    <TreeListRoot>
      <thead>
        <tr>
          {headersConfig.map(header => (
            <th key={header.key}>
              <div>{formatMessage({ id: header.label })}</div>
            </th>
          ))}
          <th />
        </tr>
      </thead>

      <tbody>
        {serviceProcesses.map(serviceProcess => (
          <TreeNode
            key={serviceProcess.pid}
            serviceProcess={serviceProcess}
            currentOpen={currentOpen}
            setCurrentOpen={setCurrentOpen}
          />
        ))}
      </tbody>
    </TreeListRoot>
  );
};
